import { createContext, useState } from "react";
import { notificationError } from "../../services/notification";
import { IContext, IListRecordProvider, IParams } from "./types";

export const ListRecordContext = createContext<IContext>({} as IContext)

export const ListRecordProvider = ({ children }: IListRecordProvider) => {
  const [record, setRecord] = useState<any>({});

  function addRecord(key: string, param: IParams) {
    if(!key || !param) return
    setRecord({...record,[key]: param})
  }

  function removeRecord(key: string) {
    if(!record[key]) return 
    let recordToRemove = record
    setRecord(recordToRemove)
  }

  function getRecord(key?: string) {
    if(!key || !record[key]) return
    return record[key]
  }

  return (
    <ListRecordContext.Provider value={{ addRecord, removeRecord, getRecord }}>
      {children}
    </ListRecordContext.Provider>
  )
}